import React from 'react'
import { useNotify } from 'react-admin'
import {
    JsonFormsWrapper as BaseJsonFormsWrapper,
    AdvancedMapperTester,
} from '@thefront/configform'
import AdvancedMapperControl from './AdvancedMapper'

// Wraps configform's JsonFormsWrapper for the react-admin apps: configuration
// problems surface as react-admin notifications, and the deprecated
// AdvancedMapperControl is injected via extraRenderers. It lives here rather
// than in configform because it pulls in final-form / mui-rff /
// react-final-form-* deps that cliconfigs should not inherit.
export const JsonFormsWrapper = ({
    extraRenderers = [],
    onConfigProblem,
    ...props
}) => {
    const notify = useNotify()
    return (
        <BaseJsonFormsWrapper
            {...props}
            onConfigProblem={onConfigProblem ?? notify}
            extraRenderers={[
                {
                    tester: AdvancedMapperTester,
                    renderer: AdvancedMapperControl,
                },
                ...extraRenderers,
            ]}
        />
    )
}
